<template>
  <div class="l-contents-container l-global">
    <comp-header></comp-header>
    <comp-side-menu></comp-side-menu>
    <router-view></router-view>
    <comp-footer></comp-footer>
    <modal></modal>
  </div>
</template>

<script>
import CompHeader from '../components/shared/vue/CompHeader'
import CompFooter from '../components/shared/vue/CompFooter'
import CompSideMenu from '../components/shared/vue/CompSideMenu'
import Modal from '../components/modal/vue/Modal'

// Prevent press ENTER keyboard to submit form
$(document).keypress(
  function (event) {
    var node = (event.target) ? event.target : ((event.srcElement) ? event.srcElement : null)
    if ((event.keyCode === 13) && (node.type === 'text')) {
      return event.preventDefault()
    }
  }
)

export default {
  name: 'index',
  components: {
    CompHeader,
    CompFooter,
    CompSideMenu,
    Modal
  }
}
</script>

<style lang="scss">
  @import "../object/scss/Object";
  @import "../object/scss/Slick";
  @import "../layout/scss/Layout";
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue